import React from "react";
import "./styles.scss";
import { Button } from "antd";

const CareersPage = () => {
  return (
    <section className="careers-content-section">
      <div className="heading-text">Careers / join us</div>
      <div className="sub-title-text">#team #careers #join #passion</div>
      <div className="desc-text">
        <span className="bold-text">Currently our team is complete,</span> but
        if you really enchanted us with your portfolio, we may consider finding
        you a desk.
      </div>
      <a href="mailto:contact@shiftedpixel.io">
        <Button className="more-games-btn">Apply Now</Button>
      </a>
    </section>
  );
};

export default CareersPage;
